import s from "../product.module.css";
import {ReactComponent as Like} from "../../../../img/categories/assets/like.svg";
import {ReactComponent as Compare} from "../../../../img/categories/assets/compare.svg";
import {ReactComponent as LikeSocial} from "../../../../img/categories/assets/likesocial.svg";
import {ReactComponent as Twitter} from "../../../../img/categories/assets/twitter.svg";
import React, {useState} from "react";


const ProductIcons=()=>{
    const [likesCount, setLikesCount] = useState(0);


    return(
        <div className={s.productIcons}>
            <div><Like/></div>
            <div><Compare/></div>
            <div onClick={() => setLikesCount(likesCount + 1)}>
                <LikeSocial/><span>Like <span>{likesCount}</span></span></div>
            <div><Twitter/></div>

        </div>
    )
}

export default ProductIcons;